import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'
import Checklist from '@repo/datalayer/store/models/Checklist'
import { useCallback, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

export function RunnerDialog({
  checklist,
  children,
  initialItemIndex,
}: {
  checklist: Checklist
  children: React.ReactNode
  initialItemIndex: number
}) {
  const [index, setIndex] = useState(initialItemIndex)
  const [open, setOpen] = useState(false)
  const { t } = useTranslation()

  const item = useMemo(() => checklist.items[index], [checklist, index])

  const nextItem = useCallback(() => {
    if (index < checklist.items.length - 1) {
      setIndex(index + 1)
    } else {
      setIndex(0)
    }
  }, [index, checklist])

  const prevItem = useCallback(() => {
    if (index > 0) {
      setIndex(index - 1)
    } else {
      setIndex(checklist.items.length - 1)
    }
  }, [index, checklist])

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="sm:max-w-[425px] rounded-2xl">
        <DialogHeader>
          <DialogTitle>{checklist.name}</DialogTitle>
          <DialogDescription></DialogDescription>
        </DialogHeader>
        <div>
          {item && (
            <div>
              <div>{item.name}</div>
              <div>{item.description}</div>
            </div>
          )}
          <div>
            <Button onClick={prevItem}>{t('back')}</Button>
            <Button onClick={nextItem}>{t('next')}</Button>
          </div>
        </div>
        <DialogFooter className="!justify-between gap-2">
          <Button
            variant="secondary"
            type="button"
            onClick={() => setOpen(false)}
          >
            {t('back')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
